export enum IntubationConstants {
  NOT_IMPLEMENTED = 'intubation/NOT_IMPLEMENTED',
  SET_DATE = 'intubation/SET_DATE',
  SET_TIME = 'intubation/SET_TIME',
  SET_DATE_TIME = 'intubation/SET_DATE_TIME',
  SET_ASSESSED_BY = 'intubation/SET_ASSESSED_BY',
  SET_SUCCESSFUL_ATTEMPT = 'intubation/SET_SUCCESSFUL_ATTEMPT',
  SET_PTA = 'intubation/SET_PTA',
  SET_ATTEMPTS = 'intubation/SET_ATTEMPTS',
  SET_SIZE = 'intubation/SET_SIZE',
  SET_DISTANCE = 'intubation/SET_DISTANCE',
  SET_DISTANCE_UNIT = 'intubation/SET_DISTANCE_UNIT',
  SET_METHOD = 'intubation/SET_METHOD',
  SET_SECURED_VIA = 'intubation/SET_SECURED_VIA',
  SET_VERIFIED_BY = 'intubation/SET_VERIFIED_BY',
  SET_VERIFICATION_VIA = 'intubation/SET_VERIFICATION_VIA',
  SET_AIRWAY_PLACEMENT_TECHNIQUE = 'intubation/SET_AIRWAY_PLACEMENT_TECHNIQUE',
  SET_AIRWAY_PLACEMENT_TECHNIQUE_PNNV = 'intubation/SET_AIRWAY_PLACEMENT_TECHNIQUE_PNNV',
  SET_RSI_PROTOCOL = 'intubation/SET_RSI_PROTOCOL',
  SET_MALLAMPATI = 'intubation/SET_MALLAMPATI',
  SET_SELLICK_MANEUVER = 'intubation/SET_SELLICK_MANEUVER',
  SET_LARYNGOSCOPIC_GRADE = 'intubation/SET_LARYNGOSCOPIC_GRADE',
  SET_STYLET_USED = 'intubation/SET_STYLET_USED',
  SET_CUFF_FILL = 'intubation/SET_CUFF_FILL',
  SET_CUFF_FILL_QTY = 'intubation/SET_CUFF_FILL_QTY',
  SET_LARYNGOSCOPE_BLADE = 'intubation/SET_LARYNGOSCOPE_BLADE',
  SET_INDICATIONS = 'intubation/SET_INDICATIONS',
  SET_DECISION_TO_MANAGE_TIME = 'intubation/SET_DECISION_TO_MANAGE_TIME',
  SET_DECISION_TO_MANAGE_DATE = 'intubation/SET_DECISION_TO_MANAGE_DATE',
  SET_DECISION_TO_MANAGE_DATE_TIME = 'intubation/SET_DECISION_TO_MANAGE_DATE_TIME',
  SET_ABANDONED_TIME = 'intubation/SET_ABANDONED_TIME',
  SET_ABANDONED_DATE = 'intubation/SET_ABANDONED_DATE',
  SET_ABANDONED_DATE_TIME = 'intubation/SET_ABANDONED_DATE_TIME',
  SET_AIRWAY_COMPLICATIONS = 'intubation/SET_AIRWAY_COMPLICATIONS',
  SET_AIRWAY_COMPLICATIONS_PNNV = 'intubation/SET_AIRWAY_COMPLICATIONS_PNNV',
  SET_PROCEDURE_COMPLICATIONS = 'intubation/SET_PROCEDURE_COMPLICATIONS',
  SET_RESPONSE = 'intubation/SET_RESPONSE',
  SET_RESPONSE_PNNV = 'intubation/SET_RESPONSE_PNNV',
  SET_AUTHORIZATION = 'intubation/SET_AUTHORIZATION',
  SET_COMMENTS = 'intubation/SET_COMMENTS',
  SET_RESPONSE_API = 'intubation/SET_RESPONSE',
  SAVE_INTUBATION = 'intubation/SAVE_INTUBATION',
  SET_ADD_TO_TIMELINE = 'intubation/SET_ADD_TO_TIMELINE',
  ON_SELECT_INTUBATION = 'intubation/ON_SELECT_INTUBATION',
  SET_STATE = 'intubation/SET_STATE',
  RESET_STATE = 'intubation/RESET_STATE',
  SET_UPDATE_INPUT_ROWS = 'intubation/SET_UPDATE_INPUT_ROWS',
  SET_ROLE_PERFORMING = 'intubation/SET_ROLE_PERFORMING',
  SET_ROLE_PERFORMING_PNNV = 'intubation/SET_ROLE_PERFORMING_PNNV',
  SET_INTUBATION_DEFAULTS = 'intubation/SET_INTUBATION_DEFAULTS',
  SET_REASONS_FOR_FAILURE = 'intubation/SET_REASONS_FOR_FAILURE',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT = 'intubation/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT',
  SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV = 'intubation/SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV',
}
